/**
 * @file 数据加密解密
 * @author svon.me@gmail.com
 **/

import CryptoJS from 'crypto-js';


/** 字符串加密 */
export const encrypt = function (value: string): string {
  const data = CryptoJS.enc.Utf8.parse(value);
  return CryptoJS.enc.Base64.stringify(data);
}

/** 字符串解密 */
export const decrypt = function (value: string): string {
  return CryptoJS.enc.Base64.parse(value).toString(CryptoJS.enc.Utf8);
}
